export default __webpack_public_path__ + "locales/vi/About.json?hash=13e76ef5faf051eecb2fd746ac2a25ff";